import { connect } from 'react-redux'

const mapStateToProps = (state) => {
  const { common: { currentSite } } = state

  return {
    currentSite
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

const createNotFoundContainer = (component) => {
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createNotFoundContainer



// WEBPACK FOOTER //
// ./client/containers/notFoundContainer.js